"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minMaxMessage = exports.veryVerySmallAmout = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const assert_1 = __importDefault(require("assert"));
exports.veryVerySmallAmout = (amount, decimals, decimalToDisplay = '4') => {
    assert_1.default(+decimals >= 0, 'decimals is required');
    const bnDecimals = new bignumber_js_1.default(10).pow(new bignumber_js_1.default(decimals));
    const amountWithDecimals = new bignumber_js_1.default(amount);
    const amountWithoutDecimals = amountWithDecimals
        .div(bnDecimals);
    if (amountWithoutDecimals.isZero()) {
        return '0';
    }
    ;
    const decimalsToDisplay = new bignumber_js_1.default(decimals).minus(new bignumber_js_1.default(decimalToDisplay));
    const minAmountToNotBeASmallAmount = new bignumber_js_1.default(10)
        .pow(decimalsToDisplay);
    const isVeryVerySmallAmount = amountWithDecimals
        .isLessThan(minAmountToNotBeASmallAmount);
    const amountToDisplay = new Intl.NumberFormat('en').format(+amountWithoutDecimals.toFixed());
    return isVeryVerySmallAmount ? 'a very little bit of' : amountToDisplay;
};
exports.minMaxMessage = (params) => {
    const { decimals, balance, symbol, amountRequired } = params;
    const defaultDecimal = decimals || 0;
    return `You have ${exports.veryVerySmallAmout(balance, defaultDecimal)} ${symbol}. You need ${exports.veryVerySmallAmout(amountRequired, defaultDecimal)} ${symbol}`;
};
//# sourceMappingURL=messageHelper.js.map